module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveShade($event)
      }
    }
  }, [_c('div', {
    staticClass: "modalContent"
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "uppercase productShadeTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.getDetails(this.$route.params.id).terms.name["en"]["value"]) + " -\n                " + _vm._s(_vm.getDetails(this.$route.params.id).terms.name["fr"]["value"]) + "\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\n                " + _vm._s(_vm.$t("product.launch")) + ": " + _vm._s(_vm.getDetails(this.$route.params.id).launchCampaign) + "\n                "), (_vm.getDetails(this.$route.params.id).discontinuedCampaign) ? _c('span', [_c('br'), _vm._v(_vm._s(_vm.$t("product.discontinued")) + ": " + _vm._s(_vm.getDetails(this.$route.params.id).discontinuedCampaign))]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "shadesTable",
      "cellpadding": "5"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "labelInput uppercase ff-medium",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t("crudComponent.name"))), _c('sup', [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShade.name),
      expression: "newShade.name"
    }],
    staticClass: "inputShades",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newShade.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newShade.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isDuplicate.name.existed) ? _c('div', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.isDuplicate.name.message),
      expression: "isDuplicate.name.message"
    }],
    class: 'duplicate-teinte'
  }) : _vm._e(), _vm._v(" "), (!_vm.isShade.name.existed) ? _c('div', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.isShade.name.message),
      expression: "isShade.name.message"
    }],
    class: 'duplicate-teinte'
  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.getShadesProperties), function(n, index) {
    return (index !== 6) ? _c('tr', {
      key: index,
      staticClass: "propertiesShades"
    }, [_c('td', {
      staticClass: "labelInput uppercase ff-medium"
    }, [_vm._v(_vm._s(n.terms.name[_vm.$t("trad")]) + " "), (!!(index == 2)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newShade.properties[index].value),
        expression: "newShade.properties[index].value"
      }],
      staticClass: "inputShades",
      staticStyle: {
        "width": "60%"
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newShade.properties[index].value)
      },
      on: {
        "mouseover": function($event) {
          _vm.hoverColorInfo(index);
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newShade.properties[index].value = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.isDuplicate.ref.existed && !!(index == 2)) ? _c('div', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: (_vm.isDuplicate.ref.message),
        expression: "isDuplicate.ref.message"
      }],
      class: 'duplicate-teinte'
    }) : _vm._e(), _vm._v(" "), (!_vm.isShade.ClientRef1.existed && !!(index == 2)) ? _c('div', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: (_vm.isShade.ClientRef1.message),
        expression: "isShade.ClientRef1.message"
      }],
      class: 'duplicate-teinte'
    }) : _vm._e(), _vm._v(" "), (index === 4) ? _c('div', {
      staticClass: "colors abs",
      style: ('background:' + _vm.newShade.properties[4].value + ';')
    }) : _vm._e(), _vm._v(" "), (index === 4) ? _c('label', {
      staticClass: "teinteCert rel",
      attrs: {
        "for": ""
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t("product.labelCertif")) + " "), _c('input', {
      staticClass: "zoneChecked",
      attrs: {
        "type": "checkbox",
        "id": "zoneChecked"
      }
    })]) : _vm._e(), _vm._v(" "), (index === 4 && _vm.showInfo === true) ? _c('div', {
      staticClass: "abs"
    }, [_vm._v("Exemple: rgb(xxx,xxx,xxx) / #727A96")]) : _vm._e()])]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "labelInput uppercase ff-medium"
  }, [_vm._v(_vm._s(_vm.$t("product.labelLancement")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.campaigns.launch.id),
      expression: "product.campaigns.launch.id"
    }],
    staticClass: "uppercase",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.campaigns.launch.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.launchCampaign), function(m) {
    return _c('option', {
      key: m.id,
      domProps: {
        "value": m.id,
        "selected": m.id == _vm.product.campaigns.launch.id
      }
    }, [_vm._v("\n                    " + _vm._s(m.name) + "\n                ")])
  })), _vm._v(" "), _c('span', {
    staticClass: "labelInput uppercase ff-medium"
  }, [_vm._v(_vm._s(_vm.$t("product.labelDiscontinuer")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShade.campaignDiscontinued.id),
      expression: "newShade.campaignDiscontinued.id"
    }],
    staticClass: "uppercase",
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newShade.campaignDiscontinued.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "uppercase",
    attrs: {
      "value": "null",
      "selected": ""
    }
  }, [_vm._v("Not discontinued")]), _vm._v(" "), _vm._l((_vm.discontinuedCampaign), function(m) {
    return _c('option', {
      key: m.id,
      domProps: {
        "value": m.id
      }
    }, [_vm._v(_vm._s(m.name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "labelInput uppercase ff-medium"
  }, [_vm._v(_vm._s(_vm.$t("product.labelSelectZone")))]), _vm._v(" "), _c('div', {
    staticClass: "zone"
  }, [_c('table', {
    attrs: {
      "id": "zoneTable",
      "cellpadding": "5"
    }
  }, _vm._l((_vm.zoneList), function(m, key) {
    return _c('tr', {
      key: m.id
    }, [_c('td', [_c('span', {
      staticClass: "labelInput uppercase ff-medium"
    }, [_vm._v(_vm._s(m.name))])]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "zoneChecked",
      attrs: {
        "type": "checkbox",
        "checked": "true"
      },
      on: {
        "change": function($event) {
          _vm.zoneChecked(m, $event);
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newShade.zones[key].campaignLaunch.id),
        expression: "newShade.zones[key].campaignLaunch.id"
      }],
      staticClass: "uppercase",
      on: {
        "blur": function($event) {
          _vm.campaignPerZone(_vm.newShade.zones[key].campaignLaunch.id);
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.newShade.zones[key].campaignLaunch.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.launchCampaignPerZone), function(m) {
      return _c('option', {
        key: m.id,
        domProps: {
          "value": m.id,
          "selected": m.id == _vm.product.campaigns.launch.id
        }
      }, [_vm._v(_vm._s(m.name) + "\n                                ")])
    }))]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newShade.zones[key].campaignDiscontinued.id),
        expression: "newShade.zones[key].campaignDiscontinued.id"
      }],
      staticClass: "uppercase",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.newShade.zones[key].campaignDiscontinued.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      staticClass: "uppercase",
      attrs: {
        "value": "null",
        "selected": ""
      }
    }, [_vm._v("Not discontinued")]), _vm._v(" "), _vm._l((_vm.discontinuedCampaignPerZone), function(m) {
      return _c('option', {
        key: m.id,
        domProps: {
          "value": m.id
        }
      }, [_vm._v(_vm._s(m.name) + " ")])
    })], 2)])])
  }))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn block pointer center uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d25bef7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/CreateShade.vue
// module id = 3099
// module chunks = 0